export default __webpack_public_path__ + "static/media/@achadissimosoficial.ef93016d.jpg";